import config from "@/config"
import axios from "axios"
import store from "@/store"

axios.defaults.baseURL = config.apiUrl

axios.interceptors.request.use(config => {
  store.dispatch("app/clearApiResponseState")

  config.headers = {
    ...config.headers,
    ...(store.getters["auth/isAuthenticated"] && {
      Authorization: `Bearer ${store.state.auth.token}`,
    }),
  }
  return config
})

axios.interceptors.response.use(
  response => {
    store.dispatch("app/setApiResponseState", response)

    return Promise.resolve(response)
  },
  error => {
    const isAuthenticated = store.getters["auth/isAuthenticated"]

    if (error.response) {
      store.dispatch("app/setApiResponseState", error.response)

      if (error.response.status === 401 && isAuthenticated) {
        store.dispatch("notification/error", {
          title: "Přihlášení vypršelo",
          message:
            "Vypršela platnost Vašeho přihlášení, přihlaste se prosím znovu.",
        })
        store.dispatch("auth/logout")

        return Promise.reject(error.response)
      }

      if (error.response.status === 455) {
        store.dispatch("notification/error", {
          title: "Přihlášení na facebook vypršelo",
          message:
            "Vypršela platnost Vašeho přihlášení na facebook, přihlaste se prosím znovu.",
        })
        store.dispatch("auth/revokeFacebookConnection")

        return Promise.reject(error.response)
      }

      return Promise.reject(error.response)
    } else if (error.message && error.message === "Network Error") {
      const response = {
        data: {
          error,
        },
        headers: {},
        status: 500,
        statusText: "Network Error",
      }
      store.dispatch("app/setApiResponseState", response)

      return Promise.reject(response)
    }

    return Promise.reject({
      data: {
        error,
      },
      headers: {},
      status: 500,
      statusText: "Unknown Error",
    })
  }
)
